import { FieldUserKey } from "./FieldUserKey";
import { UserTemplateSchema } from "@/modules/UserTemplate/models/UserTemplateSchema";
import { RoleInfo } from "@/modules/Roles/models/RoleInfo";
import { VoidedObject } from "@/shared/models/voided-object.model";
import { Dependency } from "@/modules/Dependencies/models/Dependency";

export class UserModel extends VoidedObject {
  _key?: string;
  avatar?: string;
  user!: string;
  email?: string;
  document?: string;
  name?: string;
  phone?: string;
  password?: string;
  roles!: string[] | RoleInfo[];
  state!: string;
  userTemplate!: string;
  schema?: UserTemplateSchema;
  extraInfoGroups!: Array<string>;
  fields!: FieldUserKey;
  versionValidation?: string;
  dependencies?: string[] | Dependency[];
  settedPassword?: boolean;
}
